import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Field } from 'redux-form/immutable';
import { SelectInput } from '../field-components';
import { required } from '../validators';
import messages from '../messages';
import { Api } from '../api';

function DisabilitySelector({ formName }) {
  const [disabilityList, setDisabilityList] = useState([]);

  useEffect(() => {
    Api.fetchInvalidList().then((res) => {
      setDisabilityList(JSON.parse(res.body));
    });
  }, []);

  return (
    <div className="item clearfix">
      <label className="form-label text-left col-md-3">
        <FormattedMessage {...messages.invalid_type_id} />
      </label>
      <Field name={`${formName}[invalid_type_id]`} type="text" component={SelectInput} validate={[required]}>
        <option value=""></option>
        {disabilityList.map((item) => (
          <option key={item.id} value={item.id}>
            {item.title}
          </option>
        ))}
      </Field>
    </div>
  );
}

export default DisabilitySelector;



// WEBPACK FOOTER //
// ./src/application-form/sections/disability-selector.js